import React from 'react';
import EmptyCell from './EmptyCell';

export default url => {
    if (url === null) {
        return <EmptyCell />;
    }

    return (
        <div className="cell" style={{ textAlign: 'center' }}>
            <img className="icon-cell" src={url} alt="icon" />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/view/common/table/formatters/IconCell.jsx